import { Filter } from 'lucide-react';
import { useState } from 'react';

import { ActionButton } from '@/shared/ui/action-button';
import { NotificationBadge } from '@/shared/ui';

import { useHeaderFilters } from '../model/use-header-filters';
import { FilterPanel } from './filter-panel';

export function FilterTrigger() {
  const [isOpen, setIsOpen] = useState(false);
  const { filterConfig } = useHeaderFilters();

  if (!filterConfig) return null;

  const triggerButton = (
    <ActionButton intent="view" className="relative h-9 gap-2">
      <Filter className="w-4 h-4" />
      <NotificationBadge count={filterConfig.activeCount} className="absolute -top-2 -right-2" />
    </ActionButton>
  );

  return (
    <FilterPanel
      open={isOpen}
      onOpenChange={setIsOpen}
      title={filterConfig.title}
      trigger={triggerButton}
      onApply={filterConfig.onApply}
      onReset={filterConfig.onReset}
      isApplyDisabled={filterConfig.isApplyDisabled}
      isResetDisabled={filterConfig.isResetDisabled}>
      {filterConfig.content}
    </FilterPanel>
  );
}
